import { Grid, IconButton, makeStyles, MenuItem, Select, Typography } from "@material-ui/core"
import React from "react"
import { ChevronLeft, ChevronRight } from "react-feather"
import { FONT_FAMILY_PRIMARY, SHADOW_GRAY_COLOR } from "../../theme"

const Paginacao = (props) => {
	const {
		inicioPagina,
		finalPagina,
		retornoDesabilitado,
		avancoDesabilitado,
		mudarPagina,
		handleChangeSelect,
		quantidadeItensPorPagina,
		quantidadeTotalItens,
		textoExibicao,
	} = props
	const classes = useStyle()

	return (
		<Grid container item xs={12}>
			<Grid item className={classes.gridItensPorPagina}>
				<Grid item container>
					<Typography variant={"body1"} className={"mt-2 mr-2"} >
						Itens por página:
					</Typography>
					<Select
						className={classes.select}
						value={quantidadeItensPorPagina}
						onChange={handleChangeSelect}
						disableUnderline
					>
						<MenuItem value={15}>15</MenuItem>
						<MenuItem value={30}>30</MenuItem>
						<MenuItem value={50}>50</MenuItem>
						<MenuItem value={100}>100</MenuItem>
					</Select>
				</Grid>
			</Grid>
			<Grid item className={classes.gridPaginas}>
				<Grid item container>
					<Typography variant={"body1"} className={"mt-2"}>
						{textoExibicao} {`${inicioPagina()} - ${finalPagina()}`} de {`${quantidadeTotalItens}`}
					</Typography>
					<IconButton disabled={retornoDesabilitado} aria-label="Voltar" onClick={() => mudarPagina(false)}>
						<ChevronLeft size={16} />
					</IconButton>
					<IconButton disabled={avancoDesabilitado} aria-label="Avançar" onClick={() => mudarPagina(true)}>
						<ChevronRight size={16} />
					</IconButton>
				</Grid>
			</Grid>
		</Grid>
	)
}

const useStyle = makeStyles((theme) => ({
	gridItensPorPagina: {
		width: "200px"
	},
	gridPaginas: {
		width: "calc(100% - 200px)"
	},
	select: {
		marginTop: "5px",
		fontSize: "1rem",
		color: SHADOW_GRAY_COLOR,
		fontFamily: FONT_FAMILY_PRIMARY,
	},
}))

export default Paginacao